export default {
  userDetails: window.localStorage.getItem("gelato")
    ? JSON.parse(window.localStorage.getItem("gelato"))
    : "",
  requestKey: "",
  mode: window.localStorage.getItem("mode")
    ? JSON.parse(window.localStorage.getItem("mode"))
    : false,
  bankNames: window.localStorage.getItem("bankListNames")
    ? JSON.parse(window.localStorage.getItem("bankListNames"))
    : "",
  bankList: [],
  subAccounts: "",
  userRole: window.localStorage.getItem("gelato")
    ? JSON.parse(window.localStorage.getItem("gelato")).role
    : "",
  settlements: {
    loading: true,
  },
  fullSettlements: {},
  settlementTransactions: {
    loading: true,
  },
  fullSettlementTransactions: {},
  settlementDetail: {
    loading: true,
  },
  rowSelected: [],
  retriesRowSelected: [],
  tranchesRowSelected: [],
  settlementTransactionDetails: {
    loading: true,
    transactions: [],
  },
  payoutDashboard: {
    loading: true,
  },
  payOutDetails: {
    loading: true,
  },
  singlePayoutDetails: {
    loading: true,
  },
  routingRules: {
    loading: true,
    rules: [],
  },
  merchantRoutingRules: {
    loading: true,
    isSettingMerchantSpecificRule: false,
  },
  merchantSpecificRules: {
    loading: true,
  },
  defaultCollectionAccount: {
    isSettingDefaultCollectionAccount: false,
  },
  fees: {
    loading: true,
  },
  directDebitRules: {
    loading: false,
  },
  directDebitCategories: [],
  settlementTranches: {
    loading: true,
    settlement_batches: [],
    page_info: {},
  },
  settlementRetries: {
    loading: true,
    settlement_retries: [],
    page_info: {},
  },
  settlementBatchDetail: {
    text: true,
  },
  subTitle: "",
  customMetaOptions: {},
  transactionTypes: [],
  priorityConfigList: { loading: true, data: [] },
  merchantAccess: {},
  activeLien: null,
};
